import { $wgsl } from "../../wgsl-preprocessor/wgsl-preprocessor";
import envMapSample from "./env_map_sample.wgsl";

export function getEnvMapSampleChunk(isGamma, isRgbm, gammaInput, hasIBL = true) {
  return $wgsl(envMapSample, { isGamma, isRgbm, gammaInput, hasIBL });
}